import { COVERAGE_REPORT_STATUS_LABEL } from './coverageReport'
import { LEAVE_DECISION_LABEL, LEAVE_STATE_LABEL, type LeaveFilters, type LeaveRow, type LeaveSource } from './leaveFigures'
import type { CoverageLookups } from './coverageReport'
import { generatedLabel, type ExportTable } from './reportExport'
import { supervisorLabel } from './supervisorLabel'

export function leaveExportTable(
  rows: LeaveRow[],
  totalDays: number,
  input: {
    source: LeaveSource
    from: string
    to: string
    filters: LeaveFilters
    lookups: Pick<CoverageLookups, 'teams' | 'supervisors'>
    generatedAt: Date
  },
): ExportTable {
  const { filters, lookups } = input
  const requested = input.source === 'requested'
  return {
    title: 'Leave and Availability Report',
    parameters: [
      { label: 'Source', value: requested ? 'Requested leave' : 'Scheduled leave' },
      { label: 'Date range', value: `${input.from} to ${input.to}` },
      { label: 'Team', value: filters.teamId ? (lookups.teams.get(filters.teamId) ?? 'Unknown') : 'All' },
      { label: 'Supervisor', value: filters.supervisorId ? supervisorLabel(filters.supervisorId, lookups) : 'All' },
      ...(requested
        ? [
            { label: 'Request state', value: filters.state ? LEAVE_STATE_LABEL[filters.state] : 'All' },
            { label: 'Decision', value: filters.decision ? LEAVE_DECISION_LABEL[filters.decision] : 'All' },
          ]
        : []),
      { label: 'Leave type', value: filters.leaveType ?? 'All' },
      { label: 'Coverage effect', value: filters.coverage ? COVERAGE_REPORT_STATUS_LABEL[filters.coverage] : 'All' },
      { label: 'Employee search', value: filters.search ? filters.search : 'None' },
    ],
    generatedAt: input.generatedAt,
    columns: [
      { header: 'Employee', width: 22 },
      { header: 'Team' },
      { header: 'Start date', width: 12 },
      { header: 'End date', width: 12 },
      { header: 'Days', numeric: true, width: 8 },
      { header: 'Leave type', width: 22 },
      ...(requested
        ? [{ header: 'Request state' }, { header: 'Decision', width: 26 }, { header: 'Decided by', width: 20 }, { header: 'Decided at', width: 18 }]
        : []),
      { header: 'Coverage effect', width: 26 },
    ],
    rows: rows.map((row) => [
      row.employee,
      row.team,
      row.startDate,
      row.endDate,
      row.days,
      row.leaveType,
      ...(requested
        ? [
            row.state ? LEAVE_STATE_LABEL[row.state] : '',
            row.decision ? LEAVE_DECISION_LABEL[row.decision] : 'None',
            row.decidedBy ?? '',
            row.decidedAt ? generatedLabel(new Date(row.decidedAt)) : '',
          ]
        : []),
      row.coverageEffect,
    ]),
    totals: { label: 'Total', values: [null, null, null, null, totalDays, ...Array(requested ? 6 : 2).fill(null)] },
  }
}
